module.exports = __webpack_public_path__ + "img/logo_light.181d93c0.png";